import React from "react";
import JobDetails from "../components/Jobs/JobDetails";

function JobDetailsPage() {
  return (
    <div>
      <JobDetails />
    </div>
  );
}

export default JobDetailsPage;
